// extracted by css-extract-rspack-plugin
export default {"card":"n64bkWiFGYg2Vxwy"};